import $ from "jquery";

// 세션정보 가져오기
export function keepChk() {
  let keepChk = window.localStorage.getItem("keepChk");
  let userId;
  let userType;
  let chanlTpcd;
  let reptName;
  let token;

  if (keepChk === null) {
    userId = window.sessionStorage.getItem("userId");
    userType = window.sessionStorage.getItem("userType");
    chanlTpcd = window.sessionStorage.getItem("channel");
    reptName = window.sessionStorage.getItem("reptName");
    token = window.sessionStorage.getItem("token");
  } else {
    userId = window.localStorage.getItem("userId");
    userType = window.localStorage.getItem("userType");
    chanlTpcd = window.localStorage.getItem("channel");
    reptName = window.localStorage.getItem("reptName");
    token = window.localStorage.getItem("token");
  }

  return [
    {
      userId: userId,
      userType: userType,
      chanlTpcd: chanlTpcd,
      reptName: reptName,
      token: token,
    },
  ];
}

export function getToken() {
  let data = keepChk();
  return data[0].token;
}
export function getReptName() {
  let data = keepChk();
  return data[0].reptName;
}
export function getUserId() {
  let data = keepChk();
  return data[0].userId;
}
export function getUserType() {
  let data = keepChk();
  return Number(data[0].userType);
}

// url 주소 마지막 값 가져오기
export function resultUrls1() {
  var url = document.location.href.split("/");
  var urls = Number(url[url.length - 1]);
  return urls;
}

// 금액 절삭
export function priceCut(number) {
  $(`.priceCut${number}`)
    .off("change")
    .on("change", function () {
      var n = $(this).val();

      if (n < 0) {
        alert("0원 이상 입력가능합니다.");
        $(this).val(0);
      } else if (n === "") {
        $(this).val("");
      } else {
        n = Math.floor(n / number) * number;
        $(this).val(n);
      }
    });
}

export function uuidMake() {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwsyz";
  let result = "";
  for (var i = 0; i < 5; i++) {
    var randomIndex = Math.floor(Math.random() * chars.length);
    result += chars.charAt(randomIndex);
  }

  return result;
}
export function getUuidMake(shopId) {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwsyz";
  let result = "";

  for (let i = 0; i < 5; i++) {
    let randomIndex = Math.floor(Math.random() * chars.length);
    result += chars.charAt(randomIndex);
  }

  return `CW-${shopId}${result}`;
}

export function dayChange(data) {
  let day = new Date(data);
  let year = day.getFullYear();
  let month = day.getMonth() + 1;
  let date = day.getDate();

  return `${year}-${month.toString().padStart(2, "0")}-${date.toString().padStart(2, "0")}`;
}
